import { CodeBlock } from './CodeBlock'

interface PythonCodeBlockProps {
  code: string
  className?: string
}

export function PythonCodeBlock({
  code,
  className = '',
}: PythonCodeBlockProps) {
  return (
    <CodeBlock
      code={code}
      language="python"
      label="Python Code"
      className={className}
    />
  )
}
